/**
 * File: en_US.js
 * Project: Noname-Base-Frontend
 * File Created: Wednesday, 11th June 2025 3:44:12 pm
 * Author: Jorge Sierra Blázquez (jorge.sierra@aerin.es)
 * Version: 2.0.0
 * -----
 * Last Modified: Monday, 4th August 2025 1:29:36 pm
 * Modified By: Alexandru Ionut Dascalu
 * -----
 * Copyright (c) 2023 - 2025 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 */

/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
  07.21.Wizards
  07.22.Errors
*/

module.exports = {
  /* 01.General */
  'general.copyright': 'Noname © 2022 All Rights Reserved.',
  'general.project-name': 'NONAME',

  'unauthorized.title': 'Unauthorized Access Attempt',
  'unauthorized.detail':
    'You are not authorized to view the page you are trying to access.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'Login',
  'user.register': 'Register',
  'user.forgot-password': 'Forgot Password',
  'user.email': 'E-mail',
  'user.password': 'Password',
  'user.forgot-password-question': 'Forget password?',
  'user.fullname': 'Full Name',
  'user.login-button': 'LOGIN',
  'user.login-sso': 'Login with SSO',
  'user.sso-redirecting': 'Redirecting...',
  'user.sso-authenticating': 'Authenticating...',
  'user.sso-error':
    'SSO login failed. Check that your user has access to the application or log in with username and password.',
  'user.sso-error-user-not-found':
    'Your account is not registered in the application. Contact the administrator to get access.',
  'user.sso-error-inactive':
    'Your user is deactivated. Contact the administrator.',
  'user.register-button': 'REGISTER',
  'user.reset-password-button': 'RESET',
  'user.buy': 'BUY',
  'user.username': 'Username',
  'user.new-password-again': 'New Password Again',
  'user.new-password': 'New Password',
  'user.reset-password': 'Reset Password',
  'user.warning-message': 'Please use your credentials to access.',
  'user.error.internal-server':
    'Internal server error. Please try again later.',
  'user.error.invalid-credentials':
    'Invalid credentials. Please check your username and password.',
  'user.error.generic': 'An error occurred. Please try again.',
  'user.error.no-response':
    'No response from server. Please check your connection or try again later.',
  'user.error.config-request': 'Error configuring the request.',
  'user.error.login': 'Login error.',
  'user.error.expired-token': 'Expired session token.',

  /* 03.Menu */
  'menu.home': 'Home',
  'menu.app': 'Home',
  'menu.dashboards': 'Dashboards',
  'menu.default': 'Default',
  'menu.analytics': 'Analytics',
  'menu.ecommerce': 'Ecommerce',
  'menu.content': 'Content',
  'menu.pages': 'Pages',
  'menu.administration': 'Adminstration',
  'menu.audits': 'Audits',
  'menu.accounts': 'Users',
  'menu.list': 'list',
  'menu.data-list': 'Data List',
  'menu.thumb-list': 'Thumb List',
  'menu.image-list': 'Image List',
  'menu.details': 'Details',
  'menu.search': 'Search',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.forgot-password': 'Forgot Password',
  'menu.error': 'Error',
  'menu.applications': 'Applications',
  'menu.todo': 'To-do List',
  'menu.survey': 'Survey',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.alerts': 'Alerts',
  'menu.badges': 'Badges',
  'menu.buttons': 'Buttons',
  'menu.cards': 'Cards',
  'menu.carousel': 'Carousel',
  'menu.charts': 'Charts',
  'menu.collapse': 'Collapse',
  'menu.dropdowns': 'Dropdowns',
  'menu.editors': 'Editors',
  'menu.form-layouts': 'Form Layouts',
  'menu.form-components': 'Form Components',
  'menu.form-validations': 'Form Validations',
  'menu.form-wizard': 'Form Wizard',
  'menu.icons': 'Icons',
  'menu.input-groups': 'Input Groups',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navigation',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'Sortable',
  'menu.tables': 'Tables',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Subhidden',
  'menu.hidden': 'Hidden',
  'menu.visible': 'Visible',
  'menu.maps': 'Maps',
  'menu.landingpage': 'Landing Page',
  'menu.multipage-home': 'Multipage Home',
  'menu.singlepage-home': 'Singlepage Home',
  'menu.about': 'About',
  'menu.auth-login': 'Auth Login',
  'menu.auth-register': 'Auth Register',
  'menu.reset-password': 'Reset Password',
  'menu.blog': 'Blog',
  'menu.blog-list': 'Blog List',
  'menu.blog-detail': 'Blog Detail',
  'menu.careers': 'Careers',
  'menu.confirmation': 'Confirmation',
  'menu.contact': 'Contact',
  'menu.docs': 'Docs',
  'menu.features': 'Features',
  'menu.prices': 'Prices',
  'menu.videos': 'Videos',
  'menu.mailing': 'Mailing',
  'menu.invoice': 'Invoice',
  'menu.blank-page': 'Blank Page',
  'menu.types': 'Menu Types',
  'menu.levels': 'Menu Levels',
  'menu.third-level-1': 'Third Level 1',
  'menu.third-level-2': 'Third Level 2',
  'menu.third-level-3': 'Third Level 3',
  'menu.faq': 'Faq',
  'menu.knowledge-base': 'Knowledge Base',
  'menu.authorization': 'Authorization',
  'menu.profile': 'Profile',
  'menu.product': 'Product',
  'menu.miscellaneous': 'Miscellaneous',
  'menu.portfolio': 'Portfolio',
  'menu.social': 'Social',
  'menu.details-alt': 'Details Alt',
  'menu.forms': 'Forms',
  'menu.components': 'Components',
  'menu.layouts': 'Layouts',
  'menu.validations': 'Validations',
  'menu.wizard': 'Wizard',

  /* Administration.accounts */
  'administration.accounts.create': 'Create',
  'administration.accounts.cancel': 'Cancel',
  'administration.accounts.tittle.create': 'Create new user',
  'administration.accounts.username': 'Username',
  'administration.accounts.email': 'Email',
  'administration.accounts.name': 'Name',
  'administration.accounts.lastname': 'Last Name',
  'administration.accounts.password': 'Password',
  'administration.accounts.confirmpassword': 'Confirm password',
  'administration.accounts.staff': 'Staff',
  'administration.accounts.administrator': 'Administrator',
  'administration.accounts.edit': 'Edit',
  'administration.accounts.delete': 'Delete',

  /* Administration.audits */
  'administration.audits.criticality': 'Criticality',
  'administration.audits.date': 'Date',
  'administration.audits.app': 'Application',
  'administration.audits.application': 'Application name',
  'administration.audits.message': 'Message',

  /* 04.Dashboards */
  'dashboards.pending-orders': 'Pending Orders',
  'dashboards.completed-orders': 'Completed Orders',
  'dashboards.refund-requests': 'Refund Requests',
  'dashboards.new-comments': 'New Comments',
  'dashboards.sales': 'Sales',
  'dashboards.orders': 'Orders',
  'dashboards.refunds': 'Refunds',
  'dashboards.recent-orders': 'Recent Orders',
  'dashboards.product-categories': 'Product Categories',
  'dashboards.cakes': 'Cakes',
  'dashboards.tickets': 'Tickets',
  'dashboards.calendar': 'Calendar',
  'dashboards.best-sellers': 'Best Sellers',
  'dashboards.website-visits': 'Website Visits',
  'dashboards.unique-visitors': 'Unique Visitors',
  'dashboards.this-week': 'This Week',
  'dashboards.last-week': 'Lat Week',
  'dashboards.this-month': 'This Month',
  'dashboards.conversion-rates': 'Conversion Rates',
  'dashboards.per-session': 'Per Session',
  'dashboards.profile-status': 'Profile Status',
  'dashboards.payment-status': 'Payment Status',
  'dashboards.work-progress': 'Work Progress',
  'dashboards.tasks-completed': 'Tasks Completed',
  'dashboards.payments-done': 'Payments Done',
  'dashboards.order-stock': 'Order - Stock',
  'dashboards.categories': 'Categories',
  'dashboards.quick-post': 'Quick Post',
  'dashboards.title': 'Title',
  'dashboards.content': 'Content',
  'dashboards.category': 'Category',
  'dashboards.save-and-publish': 'Save and Publish',
  'dashboards.top-viewed-posts': 'Top Viewed Posts',
  'dashboards.posts': 'Posts',
  'dashboards.pending-for-publish': 'Pending for publish',
  'dashboards.users': 'Users',
  'dashboards.on-approval-process': 'On approval process',
  'dashboards.alerts': 'Alerts',
  'dashboards.waiting-for-notice': 'Waiting for notice',
  'dashboards.files': 'Files',
  'dashboards.pending-for-print': 'Pending for print',
  'dashboards.logs': 'Logs',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'MAGIC IS IN THE DETAILS',
  'dashboards.yes-it-is-indeed': 'Yes, it is indeed!',
  'dashboards.advanced-search': 'Advanced Search',
  'dashboards.toppings': 'Toppings',
  'dashboards.type': 'Type',
  'dashboards.keyword': 'Keyword',
  'dashboards.search': 'Search',
  'dashboards.top-rated-items': 'Top Rated Items',

  /* 05.Pages */
  'pages.add-new': 'ADD NEW',
  'pages.add-new-modal-title': 'Add New Item',
  'pages.display-options': 'Display Options',
  'pages.orderby': 'Order By : ',
  'pages.total': 'Total: ',
  'pages.viewing': 'Viewing : ',
  'pages.product-name': 'Product Name',
  'pages.category': 'Category',
  'pages.description': 'Description',
  'pages.status': 'Status',
  'pages.cancel': 'Cancel',
  'pages.submit': 'Submit',
  'pages.delete': 'Delete',
  'pages.another-action': 'Another action',
  'pages.actions': 'ACTIONS',
  'pages.header': 'Header',
  'pages.details': 'DETAILS',
  'pages.orders': 'ORDERS',
  'pages.rating': 'Rating',
  'pages.price': 'Price',
  'pages.ingredients': 'Ingredients',
  'pages.is-vegan': 'Is Vegan',
  'pages.order-status': 'Order Status',
  'pages.bake-progress': 'Bake Progress',
  'pages.popularity': 'Popularity',
  'pages.comments': 'Comments',
  'pages.error-title': 'Ooops... looks like an error occurred!',
  'pages.error-code': 'Error code',
  'pages.go-back-home': 'GO BACK HOME',
  'pages.mailing-info':
    'Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Invoice template has an inline styled version for usage outside of the project as well as React version.',
  'pages.react-version': 'React Version',
  'pages.inline-version': 'Inline Styled Html Version',
  'pages.like': 'Like',
  'pages.likes': 'Likes',
  'pages.details-title': 'Details',
  'pages.comments-title': 'Comments',
  'pages.questions-title': 'Questions',
  'pages.similar-projects': 'Similar Projects',
  'pages.send': 'Send',
  'pages.addComment': 'Add a comment',
  'pages.location': 'Location',
  'pages.responsibilities': 'Responsibilities',
  'pages.photos': 'Photos',
  'pages.who-to-follow': 'Who to Follow',
  'pages.follow': 'FOLLOW',
  'pages.followers': 'FOLLOWERS',
  'pages.recent-posts': 'Recent Posts',
  'pages.profile': 'PROFILE',
  'pages.friends': 'FRIENDS',
  'pages.images': 'IMAGES',
  'pages.purchase': 'PURCHASE',
  'pages.price.developer': 'DEVELOPER',
  'pages.price.team': 'TEAM',
  'pages.price.enterprise': 'ENTERPRISE',
  'pages.price.twofactorauthentication': 'Two factor authentication',
  'pages.price.teampermissions': 'Team permissions',
  'pages.price.245Support': '24/5 Support',
  'pages.price.247Support': '24/7 Support',
  'pages.price.useractionsauditlog': 'User actions audit log',
  'pages.prices.featurecomparison': 'Feature Comparison',
  'pages.prices.pricecomparison': 'Price Comparison',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'Messages',
  'chat.contacts': 'Contacts',
  'chat.saysomething': 'Say something..',

  /* 06.02.Survey */
  'survey.delete': 'Delete',
  'survey.edit': 'Edit',
  'survey.add-new': 'ADD NEW',
  'survey.add-new-title': 'Add New Survey',
  'survey.title': 'Title',
  'survey.category': 'Category',
  'survey.label': 'Label',
  'survey.status': 'Status',
  'survey.cancel': 'Cancel',
  'survey.submit': 'Submit',
  'survey.another-action': 'Another action',
  'survey.display-options': 'Display Options',
  'survey.orderby': 'Order By : ',
  'survey.all-surveys': 'All Surveys',
  'survey.completed-surveys': 'Completed Surveys',
  'survey.categories': 'Categories',
  'survey.active-surveys': 'Active Surveys',
  'survey.labels': 'Labels',

  /* 06.03.Todo */
  'todo.add-new': 'ADD NEW',
  'todo.add-new-title': 'Add New Todo',
  'todo.title': 'Title',
  'todo.detail': 'Detail',
  'todo.category': 'Category',
  'todo.label': 'Label',
  'todo.status': 'Status',
  'todo.cancel': 'Cancel',
  'todo.submit': 'Submit',
  'todo.action': 'Action',
  'todo.another-action': 'Another action',
  'todo.display-options': 'Display Options',
  'todo.orderby': 'Order By : ',
  'todo.all-tasks': 'All Tasks',
  'todo.pending-tasks': 'Pending Tasks',
  'todo.completed-tasks': 'Completed Tasks',
  'todo.categories': 'Categories',
  'todo.labels': 'Labels',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Rounded Alert',
  'alert.react-notifications': 'React Notifications',
  'alert.outline': 'Outline',
  'alert.primary': 'Primary',
  'alert.secondary': 'Secondary',
  'alert.info': 'Info',
  'alert.success': 'Success',
  'alert.warning': 'Warning',
  'alert.error': 'Error',
  'alert.filled': 'Filled',
  'alert.primary-text': 'This is a primary alert—check it out!',
  'alert.secondary-text': 'This is a secondary alert—check it out!',
  'alert.success-text': 'This is a success alert—check it out!',
  'alert.danger-text': 'This is a danger alert—check it out!',
  'alert.warning-text': 'This is a warning alert—check it out!',
  'alert.info-text': 'This is a info alert—check it out!',
  'alert.light-text': 'This is a light alert—check it out!',
  'alert.dark-text': 'This is a dark alert—check it out!',
  'alert.default': 'Default Alert',
  'alert.dismissing': 'Dismissing Alert',
  'alert.dismissing-text':
    'Holy guacamole! You should check in on some of those fields below.',
  'alert.dismissing-without-animate-text':
    'I am an alert and I can be dismissed without animating!',

  /* 07.02.Badges */
  'badge.sizes': 'Sizes',
  'badge.colors': 'Colors',
  'badge.outline': 'Outline',
  'badge.links': 'Links',
  'badge.counter-badges': 'Counter Badges',
  'badge.bootstrap-default': 'Bootstrap Default',
  'badge.primary': 'Primary',
  'badge.secondary': 'Secondary',
  'badge.success': 'Success',
  'badge.danger': 'Danger',
  'badge.warning': 'Warning',
  'badge.info': 'Info',
  'badge.light': 'Light',
  'badge.dark': 'Dark',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap Default',
  'button.colors': 'Colors',
  'button.rounded': 'Rounded',
  'button.outline': 'Outline',
  'button.states': 'States',
  'button.sizes': 'Sizes',
  'button.button-groups': 'Button Groups',
  'button.large-button': 'Large Button',
  'button.small-button': 'Small Button',
  'button.extra-small-button': 'Extra Small Button',
  'button.block-button': 'Block Button',
  'button.active': 'Active',
  'button.disabled': 'Disabled',
  'button.basic': 'Basic',
  'button.toolbar': 'Toolbar',
  'button.nesting': 'Nesting',
  'button.vertical-variation': 'Vertical Variation',
  'button.checkbox-radio-button': 'Checkbox and Radio Button',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primary',
  'button.secondary': 'Secondary',
  'button.success': 'Success',
  'button.danger': 'Danger',
  'button.warning': 'Warning',
  'button.info': 'Info',
  'button.light': 'Light',
  'button.dark': 'Dark',
  'button.states-text':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.click-here': 'Click Here',
  'button.states-text-alternate':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.primary-link': 'Primary Link',
  'button.link': 'Link',
  'button.primary-button': 'Primary Button',
  'button.button': 'Button',
  'button.left': 'Left',
  'button.middle': 'Middle',
  'button.right': 'Right',
  'button.dropdown': 'Dropdown',
  'button.dropdown-link': 'Dropdown Link',

  /* 07.04.Cards */
  'cards.icon-card': 'Icon Card',
  'cards.image-card': 'Image Card',
  'cards.image-overlay-card': 'Image Overlay Card',
  'cards.image-card-list': 'Image Card List',
  'cards.tab-card': 'Tab Card',
  'cards.user-card': 'User Card',

  /* 07.05.Carousel */
  'carousel.basic': 'Carousel Basic',
  'carousel.single': 'Carousel Single',
  'carousel.without-controls': 'Carousel Without Controls',

  /* 07.06.Charts */
  'charts.line': 'Line Chart',
  'charts.polar': 'Polar Chart',
  'charts.area': 'Area Chart',
  'charts.scatter': 'Scatter Chart',
  'charts.bar': 'Bar Chart',
  'charts.radar': 'Radar Chart',
  'charts.pie': 'Pie Chart',
  'charts.doughnut': 'Doughnut Chart',
  'charts.shadow': 'Shadow',
  'charts.no-shadow': 'No Shadow',

  /* 07.07.Collapse */
  'collapse.basic': 'Basic',
  'collapse.toggle': 'Toggle',
  'collapse.accordion': 'Accordion',
  'collapse.controlled': 'Controlled',
  'collapse.uncontrolled': 'Uncontrolled',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Basic',
  'dropdowns.controlled': 'Controlled',
  'dropdowns.uncontrolled': 'Uncontrolled',
  'dropdowns.dropdown': 'Dropdown',
  'dropdowns.header': 'Header',
  'dropdowns.action': 'Action',
  'dropdowns.another-action': 'Another Action',
  'dropdowns.right': 'Right',
  'dropdowns.left': 'Left',
  'dropdowns.drop-directions': 'Drop Directions',
  'dropdowns.dropright': 'Dropright',
  'dropdowns.dropleft': 'Dropleft',
  'dropdowns.small-button': 'Small Button',
  'dropdowns.large-button': 'Large Button',
  'dropdowns.sizing': 'Sizing',
  'dropdowns.split-button': 'Split Button Dropdowns',
  'dropdowns.dropup': 'Dropup',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'Basic',
  'forms.email': 'E-mail',
  'forms.email-muted': "We'll never share your email with anyone else.",
  'forms.password': 'Password',
  'forms.password-confirm': 'Confirm Password',
  'forms.submit': 'Submit',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'First radio',
  'forms.second-radio': 'Second radio',
  'forms.third-radio-disabled': 'Third disabled radio',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Sign in',
  'forms.top-labels-over-line': 'Top Labels Over Line',
  'forms.tags': 'Tags',
  'forms.date': 'Date',
  'forms.state': 'State',
  'forms.top-labels-in-input': 'Top Labels In Input',
  'forms.email-u': 'E-MAIL',
  'forms.password-u': 'PASSWORD',
  'forms.tags-u': 'TAGS',
  'forms.date-u': 'DATE',
  'forms.state-u': 'STATE',
  'forms.grid': 'Form Grid',
  'forms.address': 'Address',
  'forms.address2': 'Address 2',
  'forms.city': 'City',
  'forms.city-message': 'Please select a city!',
  'forms.state-message': 'Please select a state!',
  'forms.zip': 'Zip',
  'forms.signup': 'Signup',
  'forms.inline': 'Inline',
  'forms.validation': 'Validation',
  'forms.default': 'Default',
  'forms.firstname': 'First name',
  'forms.firstname-message': 'Please enter your first name!',
  'forms.lastname': 'Last name',
  'forms.lastname-message': 'Please enter your last name!',
  'forms.name': 'Name',
  'forms.validation-availity': 'Availity Reactstrap Validation',
  'forms.validation-formik': 'Formik Validation',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Custom Inputs',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radios',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'State Single',
  'form-components.state-multiple': 'State Multiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Date Picker',
  'form-components.date': 'Date',
  'form-components.date-range': 'Date Range',
  'form-components.date-with-time': 'Date with Time',
  'form-components.embedded': 'Embedded',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Drop Files Here',
  'form-components.tags': 'Tags',
  'form-components.switch': 'Switch',
  'form-components.primary': 'Primary',
  'form-components.secondary': 'Secondary',
  'form-components.primary-inverse': 'Primary Inverse',
  'form-components.secondary-inverse': 'Secondary Inverse',
  'form-components.slider': 'Slider',
  'form-components.double-slider': 'Double Slider',
  'form-components.single-slider': 'Single Slider',
  'form-components.rating': 'Rating',
  'form-components.interactive': 'Interactive',
  'form-components.readonly': 'Readonly',
  'form-components.type-a-cake': 'Type a Cake',
  'form-components.start': 'Start',
  'form-components.end': 'End',
  'form-components.tables': 'Tables',

  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line Icons',
  'icons.iconsmind': 'Iconsmind Icons',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Basic',
  'input-groups.sizing': 'Sizing',
  'input-groups.small': 'Small',
  'input-groups.default': 'Default',
  'input-groups.large': 'Large',
  'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
  'input-groups.multiple-inputs': 'Multiple Inputs',
  'input-groups.first-and-last-name': 'First and last name',
  'input-groups.multiple-addons': 'Multiple Addons',
  'input-groups.button-addons': 'Button Addons',
  'input-groups.button': 'Button',
  'input-groups.buttons-with-dropdowns': 'Buttons with Dropdowns',
  'input-groups.dropdown': 'Dropdown',
  'input-groups.header': 'Header',
  'input-groups.action': 'Action',
  'input-groups.another-action': 'Another Action',
  'input-groups.custom-select': 'Custom Select',
  'input-groups.options': 'Options',
  'input-groups.choose': 'Choose...',
  'input-groups.custom-file-input': 'Custom File Input',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hello, world!',
  'jumbotron.lead':
    'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.',
  'jumbotron.lead-detail':
    'It uses utility classes for typography and spacing to space content out within the larger container.',
  'jumbotron.learn-more': 'Learn more',

  /* 07.15.Modal */
  'modal.basic': 'Basic',
  'modal.modal-title': 'Modal title',
  'modal.launch-demo-modal': 'Launch Demo Modal',
  'modal.scrolling-long-content': 'Scrolling Long Content',
  'modal.backdrop': 'Backdrop',
  'modal.backdrop-value': 'Backdrop value',
  'modal.right-modal': 'Right Modal',
  'modal.launch-right-modal': 'Launch Right Modal',
  'modal.nested-modal': 'Nested Modal',
  'modal.size': 'Size',
  'modal.launch-large-modal': 'Launch Large Modal',
  'modal.launch-small-modal': 'Launch Small Modal',

  /* 07.16.Navigation */
  'nav.basic': 'Nav Basic',
  'nav.active': 'Active',
  'nav.disabled': 'Disabled',
  'nav.disabled-link': 'Disabled Link',
  'nav.link': 'Link',
  'nav.longer-link': 'Longer nav link',
  'nav.another-link': 'Another Link',
  'nav.right': 'Right',
  'nav.dropdown': 'Dropdown',
  'nav.header': 'Header',
  'nav.action': 'Action',
  'nav.another-action': 'Another Action',
  'nav.horizontal-alignment': 'Nav Horizontal Alignment',
  'nav.vertical-alignment': 'Nav Vertical Alignment',
  'nav.pills': 'Nav Pills',
  'nav.fill-justify': 'Nav Fill and Justify',
  'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
  'nav.pagination-basic': 'Pagination Basic',
  'nav.pagination-sizing': 'Pagination Sizing',
  'nav.large': 'Large',
  'nav.small': 'Small',
  'nav.center': 'Center',
  'nav.pagination-alignment': 'Pagination Alignment',
  'nav.breadcrumb-basic': 'Breadcrumb Basic',
  'nav.dark-mode': 'Dark Mode',
  'nav.log-out': 'Log Out',
  'nav.maximize': 'Maximize',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Tooltip',

  /* 07.18.Sortable */
  'sortable.columns': 'Sorting Columns',
  'sortable.basic': 'Basic',
  'sortable.handles': 'Handles',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap Tables',
  'table.bootstrap-basic': 'Basic Table',
  'table.bootstrap-striped': 'Striped Rows',
  'table.bootstrap-bordered': 'Bordered Table',
  'table.bootstrap-borderless': 'Borderless Table',
  'table.bootstrap-hoverable': 'Hoverable Rows',
  'table.bootstrap-responsive': 'Responsive Table',
  'table.react-tables': 'React Tables',
  'table.react-pagination': 'Pagination',
  'table.react-scrollable': 'Scrollable',
  'table.react-advanced': 'Filter, Length and Jump',
  'table.divided': 'Divided Table',

  /* 07.21.Wizards */
  'wizard.step-name-1': 'Step 1',
  'wizard.step-name-2': 'Step 2',
  'wizard.step-name-3': 'Step 3',
  'wizard.step-desc-1': 'First step description',
  'wizard.step-desc-2': 'Second step description',
  'wizard.step-desc-3': 'Third step description',
  'wizard.content-1': 'Step content for first step.',
  'wizard.content-2': 'Step content for second step.',
  'wizard.content-3': 'Last step content!',
  'wizard.content-thanks': 'Thank You!',
  'wizard.next': 'Next',
  'wizard.prev': 'Back',
  'wizard.registered': 'Your registration completed successfully!',
  'wizard.async': 'Async save for 3 seconds!',

  /* 07.22.Errors */
  'error.401-not-authorized': 'Error, user session expired.',
  'error.403-not-authorized':
    'Error, user does not have permissions, its recommended login again to refresh the permissions.',
  /* Modules */
  /* aiteaview_start_trans */
  'cosbim.name': 'COSBIM 360',
  'cosbim.description':
    'The leading real estate agency in quality offices in the euro zone',
  'menu.cities': 'Cities',
  'menu.administration-cosbim': 'Administration',
  'menu.buildings': 'Buildings',
  'menu.building': 'Build',
  'menu.widgets': 'Widgets',
  'menu.parameters': 'Parameters',
  'menu.documents': 'Documents',
  'menu.cosbim': 'Cosbim',
  'menu.metasys': 'Metasys',
  'menu.download': 'Download data in CSV',
  'menu.med': 'MED',
  'menu.alarms': 'Alarms',
  'menu.settings': 'Settings',
  'administration.accounts.alarms.criticity_title': 'Criticity Levels (Alarms)',
  'administration.accounts.alarms.critical': 'Critical',
  'administration.accounts.alarms.warning': 'Warning',
  'administration.accounts.alarms.minor': 'Minor',
  'administration.accounts.alarms.informational': 'Informational',
  'administration.profile': 'Profile',
  'administration.profile.edit.success': 'User edited successfully',
  'administration.users': 'Users',
  'administration.cities': 'Cities',
  'administration.buildings': 'Buildings',
  'administration.ocas': 'OCAs',
  'administration.ocas.name': 'Name',
  'administration.ocas.royal_decree': 'Royal decree',
  'administration.ocas.periodicity': 'Inspection periodicity',
  'administration.ocas.create': 'Create new installation',
  'administration.ocas.edit': 'Edit installation',
  'administration.ocas.inspection_name': 'Inspection name',
  'administration.ocas.royal_decree_name': 'Royal decree name',
  'administration.ocas.docuware_fields': 'DocuWare fields',
  'administration.ocas.doc_class_field': 'Doc class field',
  'administration.ocas.doc_subclass_field': 'Doc subclass field',
  'administration.ocas.date.missing': 'Missing',
  'administration.ocas.filter.status': 'Status',
  'administration.ocas.filter.status.all': 'All dates',
  'administration.ocas.filter.status.danger': 'Dates in red',
  'administration.ocas.filter.date': 'Inspection date',
  'administration.ocas.installations': 'Installations ',
  'administration.ocas.current_year': 'Current year: ',
  'administration.ocas.download_excel': 'Download excel',
  'administration.ocas.building.installation': 'Installation',
  'administration.ocas.building.regulation': 'Regulation',
  'administration.ocas.building.status': 'Status',
  'administration.ocas.building.next_inspection': 'Next Inspection',
  'administration.ocas.building.status.approved': 'Approved',
  'administration.ocas.building.status.conditioned': 'Conditioned',
  'administration.ocas.building.status.rejected': 'Not approved',
  'administration.ocas.building.new_inspection_date':
    'New next inspection date',
  'administration.ocas.building.conditioned_modal_title':
    'Change to conditioned status',
  'administration.ocas.building.save': 'Save',
  'administration.widgets': 'Widgets',
  'administration.widgets.list.name': 'Name',
  'administration.widgets.list.url': 'URL',
  'administration.widgets.list.type': 'Type',
  'administration.widgets.list.placement': 'Placement',
  'administration.widgets.list.position': 'Position',
  'administration.widgets.edit.tittle': 'Edit widget',
  'administration.widgets.edit.name': 'Widget name',
  'administration.widgets.list.kind': 'Family',
  'administration.widgets.edit.kind': 'Widget family',
  'administration.widgets.edit.type': 'Widget type',
  'administration.widgets.edit.placement': 'Widget placement',
  'administration.widgets.edit.position': 'Widget position',
  'administration.widgets.edit.url': 'Widget URL',
  'administration.widgets.edit.mobile_url': 'Widget mobile URL',
  'administration.widgets.edit.image': 'Widget image',
  'administration.widgets.edit.groups': 'Groups',
  'administration.widgets.edit.validation.error.title': 'Validation error',
  'administration.widgets.edit.validation.error.message':
    'Please complete all required fields: name, type, placement, position and URL',
  'administration.widgets.placement': 'Placement',
  'administration.widgets.image': 'Select an image',
  'administration.widgets.portal': 'Portal',
  'administration.widgets.cosbim': 'Cosbim',
  'administration.widgets.planos': 'Plans',
  'administration.widgets.reports': 'Reports',
  'administration.widgets.heatmap': 'Heatmap',
  'administration.widgets.intranet': 'Intranet',
  'administration.widgets.climate': 'Climate',
  'administration.widgets.lightning': 'Lighting',
  'administration.widgets.assistant': 'Assistant',
  'administration.widgets.electricidad': 'Electricity',
  'administration.widgets.agua': 'Water',
  'administration.widgets.gas': 'Gas',
  'administration.widgets.districlima': 'Districlima',
  'administration.widgets.co2': 'CO2',
  'administration.widgets.co2-ext': 'Outdoor CO2',
  'administration.widgets.cala': 'Air quality',
  'administration.widgets.temperatura': 'Temperature',
  'administration.widgets.humedad': 'Humidity',
  'administration.widgets.afluencia': 'Flow',
  'administration.widgets.contacts': 'Contacts',
  'administration.settings': 'Settings',
  'administration.settings.portfolio-coords': 'Coordinates',
  'administration.settings.latitude': 'Latitude',
  'administration.settings.longitude': 'Longitude',
  'administration.settings.market-value': 'Market Value (€m)',
  'administration.settings.total-area': 'Total Surface Area (m²)',
  'administration.settings.total-buildings': 'Number of Buildings',
  'administration.settings.portfolio-kpis': 'Portfolio KPIs',
  'administration.settings.email': 'Registration email',
  'administration.settings.csv': 'Buildings CSV',
  'administration.settings.upload.csv.datamaster': 'Upload CSV Data Master',
  'administration.settings.upload.csv.spacesclients':
    'Upload CSV Spaces Clients',
  'administration.settings.uploading': 'Uploading CSV...',
  'administration.settings.upload': 'Upload',
  'administration.settings.disclaimer.title': 'Disclaimers',
  'administration.settings.privacy.title': 'Privacy policy',
  'administration.settings.legal.hint': 'Not shown if left empty.',
  'administration.settings.legal.spanish': 'Text in Spanish',
  'administration.settings.legal.english': 'Text in English',
  'administration.settings.legal.cat': 'Text in Catalan',
  'administration.settings.legal.french': 'Text in French',
  'administration.settings.contact.title': 'Contact',
  'administration.settings.contact.hint':
    'If left empty there is no contact page. The form only appears with an email.',
  'administration.settings.contact.address': 'Address',
  'administration.settings.contact.phone': 'Phone',
  'administration.settings.contact.hours': 'Opening hours',
  'administration.settings.contact.email': 'Contact email',
  'administration.settings.save': 'Save settings',
  'administration.settings.scraper_config': 'Scraper KPI',
  'administration.settings.execution.title': 'Execution type',
  'administration.settings.execution.daily': 'Daily',
  'administration.settings.execution.weekly': 'Weekly',
  'administration.settings.execution.monthly': 'Monthly',
  'administration.settings.day.week': 'Day of the week',
  'administration.settings.day.month': 'Day of the month',
  'administration.settings.select.day': 'Select a day',
  'administration.settings.notification.scraper_updated':
    'Configuration updated successfully',
  'administration.settings.notification.updated': 'Configuration updated',
  'administration.settings.day.monday': 'Monday',
  'administration.settings.day.tuesday': 'Tuesday',
  'administration.settings.day.wednesday': 'Wednesday',
  'administration.settings.day.thursday': 'Thursday',
  'administration.settings.day.friday': 'Friday',
  'administration.settings.day.saturday': 'Saturday',
  'administration.settings.day.sunday': 'Sunday',
  'administration.scraper.save': 'Save scraper configuration',
  'administration.settings.hide_scraper_config':
    'Hide scraper KPI configuration',
  'administration.settings.show_scraper_config':
    'Show scraper KPI configuration',
  'administration.parameters': 'Parameters',
  'administration.documents': 'Documents',
  'administration.documents.assignment': 'Document assignment',
  'administration.documents.assign': 'Assign',
  'administration.documents.hide': 'Hide',
  'administration.assign.users': 'Users assigned',
  'administration.assign.cities': 'Cities assigned',
  'administration.assign.buildings': 'Buildings assigned',
  'administration.assign.widgets': 'Widgets assigned',
  'administration.assign.parameters': 'Parameters assigned',
  'administration.assign.documents': 'Documents assigned',
  'administration.assign.clients': 'Clients assigned',
  'administration.permission.user': 'Permission',
  'administration.accounts.surname': 'Surname',
  'administration.accounts.tittle.edit': 'Edit user',
  'administration.accounts.tittle.delete': 'Delete this user?',
  'administration.accounts.delete.success': 'User deleted successfully',
  'administration.accounts.type': 'Type',
  'administration.accounts.auth.internal': 'Internal',
  'administration.accounts.auth.external': 'External',
  'administration.accounts.validated.password':
    'Password must contain at least 8 characters, one uppercase letter, one number and one special character',
  'administration.accounts.selector.language': 'Language',
  'administration.accounts.selector.homescreen.placeholder':
    'Select a home screen...',
  'administration.accounts.selector.homescreen.portfolio': 'Portfolio',
  'administration.accounts.selector.homescreen.space': 'City',
  'administration.accounts.selector.homescreen.building': 'Building',
  'administration.accounts.selector.homescreen.client': 'Client',
  'administration.accounts.selector.authtype': 'Authentication Type',
  'administration.accounts.selector.authtype.placeholder':
    'Select authentication type...',
  'administration.accounts.selector.language.placeholder':
    'Select a language...',
  'administration.accounts.selector.widgets.placeholder': 'Select a widget...',
  'administration.accounts.myprofile.current_password': 'Current password',
  'administration.homescreen.portofolio': 'Portfolio',
  'administration.homescreen.space': 'City',
  'administration.homescreen.building': 'Building',
  'administration.homescreen.client': 'Client',
  'administration.cities.tittle.create': 'Create new city',
  'administration.cities.tittle.edit': 'Edit city',
  'administration.city.tittle.delete': 'Delete this city?',
  'administration.buildings.tittle.create': 'Create new building',
  'administration.buildings.tittle.edit': 'Edit building',
  'administration.buildings.tittle.warning': 'Warning',
  'administration.buildings.tittle.delete': 'Delete this building?',
  'administration.buildings.tittle.accept': 'Accept',
  'administration.buildings.image.delete': 'Delete image',
  'administration.buildings.image.delete.body':
    'Do you want to delete the image associated with client ',
  'administration.buildings.image.delete.success': 'Image deleted successfully',
  'notification.success.title': 'Success',
  'administration.buildings.create.success': 'Building created successfully',
  'administration.buildings.edit.success': 'Building edited successfully',
  'administration.buildings.longlat.validation':
    'The value must be a decimal number with a maximum of 3 integer digits and 7 decimals.',
  'administration.buildings.required_fields':
    'Fill in the following required fields:',
  'administration.buildings.fix_errors': 'Fix the errors shown before saving.',
  'administration.buildings.invalid_link':
    'The link must be a valid URL, starting with http or https.',
  'administration.buildings.tittle.cancel': 'Cancel',
  'administration.buildings.link.grafana': 'Dashboard occupation link',
  'administration.buildings.occupation': 'Datos Ocupación',
  'administration.tittle.back': 'Go back',
  'administration.building.certification': 'Certification',
  'administration.widgets.tittle.create': 'Create new widget',
  'administration.parameters.tittle.create': 'Create new parameter',
  'administration.widgets.tittle.edit': 'Edit widget',
  'administration.parameters.tittle.edit': 'Edit parameter',
  'administration.widgets.tittle.delete': 'Delete this widget?',
  'administration.widgetConf.tittle.delete': 'Delete this widget conf?',
  'administration.widgetConf.delete.success':
    'Widget conf deleted successfully',
  'administration.parameters.tittle.delete': 'Delete this parameter?',
  'administration.documents.tittle.edit': 'Edit link',
  'administration.document.edit.success': 'Link edited successfully',
  'administration.widgets.position': 'Home screen position',
  'administration.widgets.front_carusel': 'Front carusel',
  'administration.structure': 'Structure',
  'administration.widgets.url': 'URL',
  position: 'Position',
  'administration.assets': 'Type',
  'administration.img': 'Image building',
  'administration.img.city': 'Image city',
  'administration.img.widget': 'Image widget',
  img: 'Image',
  'administration.accounts.superuser': 'Super user',
  'administration.accounts.user': 'Client',
  'administration.accounts.user.can.see.administration':
    'User can see administration',
  'administration.groups.select-all': 'Select all',
  'administration.groups.deselect-all': 'Clear',
  'administration.userRoles': 'User roles',
  'administration.selectUserRole': 'Select user role',
  'administration.selectUserRoleAssistant':
    'You must select a role for the Assistant widget',
  'filter.city': 'Filter by city',
  'filter.assets': 'Filter by assets',
  'filter.projects': 'Filter by projects',
  'filter.buildings': 'Filter by building',
  'filter.widgets': 'Filter by widgets',
  'select.assets': 'Asset',
  'select.projects': 'Project',
  'module.name': 'Name module',
  'parameters.name': 'Name parameter',
  'parameters.name.required': 'The folder name is required.',
  'parameters.url': 'Link document',
  'document.send': 'Send documents',
  'document.receiver': 'Recipient',
  'document.subject': 'Subject',
  'document.comment': 'Comment',
  'document.attached': 'Attach files',
  'document.sending': 'Sending mail, please wait...',
  'document.sent': 'Mail sent successfully',
  'select.building': 'Building select',
  'url.sin.dato': '# if it is a container of another level',
  'forms.message': 'Message',
  'alert.documents': 'You must select a building to view the documentation.',
  'dashboard.title': 'Energy monitoring',
  'forms.range': 'Date range',
  'forms.year-range': 'Year range',
  'menu.consumption': 'Consumption',
  'air.quality': 'Air quality',
  'air.quality.daily': 'Outdoor air quality (daily)',
  'air.quality.monthly': 'Outdoor air quality (monthly)',
  'air.quality.yearly': 'Outdoor air quality (annual)',
  'air.quality.ext': 'Outdoor air quality',
  'air.quality.history': 'Outdoor air quality History',
  'air.co2': 'CO2',
  'air.co2.daily': 'CO2 (daily)',
  'air.co2.monthly': 'CO2 (monthly)',
  'air.co2.yearly': 'CO2 (annual)',
  'air.co2.ext': 'Outdoor CO2',
  'air.co2.history': 'CO2 History',
  'air.co2.ext.history': 'Outdoor CO2 History',
  'carbon.footprint': 'Carbon Footprint',
  'carbon.footprint.history': 'Carbon Footprint History',
  'metric.temperature-forecast': 'Temperature Forecast',
  'metric.occupation-evolution': 'Occupation Evolution',
  'metric.occupation-percentage': 'Occupancy Percentage',
  'metric.occupation-maximum-daily': 'Maximum Daily Occupancy',
  'metric.bathroom-transit': 'Bathroom Transit',
  'metric.alarms': 'Alarms',
  'building.flows': 'Flows',
  'flows.view.real': 'Real view',
  'flows.view.max': 'Maximum view',
  'flows.growth.previous_year': '(Prev. year)',
  'flows.growth.range_title': 'Total Attendance Growth',
  'chart.occupation': 'Occupation',
  'occupation.implantation': 'On implantation',
  'occupation.max_since_january': 'Maximum value since January 1st',
  'meteorology.variables.internal': 'Internal',
  'meteorology.variables.external': 'External',
  'meteorology.year.to.date': 'year to date',
  'menu.floors': 'Floors',
  'menu.customers': 'Customers',
  'menu.office': 'Offices',
  'gas.consumption': 'Gas Cons.',
  'gas.consumption.history': 'Gas Cons. History',
  'gas.consumption.daily': 'Gas Cons. (daily)',
  'gas.consumption.monthly': 'Gas Cons. (monthly)',
  'gas.consumption.yearly': 'Gas Cons. (annual)',
  'electrical.consumption': 'Elec. Cons.',
  'electrical.consumption.history': 'Elec. Cons. History',
  'electrical.consumption.daily': 'Elec. Cons. (daily)',
  'electrical.consumption.monthly': 'Elec. Cons. (monthly)',
  'electrical.consumption.yearly': 'Elec. Cons. (annual)',
  'electrical.consumption.symmetrical': 'Sym. Elec. Cons.',
  'electrical.consumption.symmetrical.history': 'Sym. Elec. Cons. History',
  'electrical.consumption.symmetrical.daily': 'Sym. Elec. Cons. (daily)',
  'electrical.consumption.symmetrical.monthly': 'Sym. Elec. Cons. (monthly)',
  'electrical.consumption.symmetrical.yearly': 'Sym. Elec. Cons. (annual)',
  'water.consumption': 'Water Cons.',
  'water.consumption.history': 'Water Cons. History',
  'water.consumption.daily': 'Water Cons. (daily)',
  'water.consumption.monthly': 'Water Cons. (monthly)',
  'water.consumption.yearly': 'Water Cons. (annual)',
  'districlima.consumption': 'DistriClima',
  'districlima.consumption.history': 'DistriClima History',
  'districlima.consumption.daily': 'DistriClima (total) (daily)',
  'districlima.consumption.monthly': 'DistriClima (total) (monthly)',
  'districlima.consumption.yearly': 'DistriClima (total) (annual)',
  'districlima.consumption.cold': 'DistriClima (cold)',
  'districlima.consumption.cold.daily': 'DistriClima (cold) (daily)',
  'districlima.consumption.cold.monthly': 'DistriClima (cold) (monthly)',
  'districlima.consumption.cold.yearly': 'DistriClima (cold) (annual)',
  'districlima.consumption.hot': 'DistriClima (heat)',
  'districlima.consumption.hot.daily': 'DistriClima (heat) (daily)',
  'districlima.consumption.hot.monthly': 'DistriClima (heat) (monthly)',
  'districlima.consumption.hot.yearly': 'DistriClima (heat) (annual)',
  'districlima.total': 'Total',
  'districlima.hot': 'Hot',
  'districlima.cold': 'Cold',
  'chart.temperature': 'Temperature',
  'chart.temperature.history': 'Temperature History',
  'chart.temperature.daily': 'Temperature (daily)',
  'chart.temperature.monthly': 'Temperature (monthly)',
  'chart.temperature.yearly': 'Temperature (annual)',
  'chart.humidity': 'Humidity',
  'chart.humidity.ext': 'Outdoor Humidity',
  'chart.humidity.history': 'Humidity History',
  'chart.humidity.daily': 'Humidity (daily)',
  'chart.humidity.monthly': 'Humidity (monthly)',
  'chart.humidity.yearly': 'Humidity (annual)',
  'meteorology.temperature': 'Temperature',
  'meteorology.humidity': 'Humidity',
  'dashboard.sub.buildings': 'Sub Buildings',
  'building.characteristics': 'General Characteristics',
  'city.madrid': 'Madrid',
  'city.barcelona': 'Barcelona',
  'city.paris': 'Paris',
  'floor.without.client': 'Without Client',
  'building.floor.ground': 'Ground Floor',
  'building.floor.1': 'Floor 1',
  'building.floor.2': 'Floor 2',
  'building.floor.3': 'Floor 3',
  'building.floor.4': 'Floor 4',
  'building.floor.5': 'Floor 5',
  'building.floor.6': 'Floor 6',
  'building.floor.7': 'Floor 7',
  'building.blueprints': 'Blueprints',
  'building.reports': 'Reports',
  'building.directory': 'Directory',
  'building.portfolio': 'Portfolio',
  'building.portfolio.group': 'Portfolio',
  'home.no-buildings': 'You have no buildings assigned yet.',
  'home.no-portfolio': 'There is no portfolio yet.',
  'aiteaview.login-sso': 'Log in with SSO',
  'administration.search': 'Search...',
  'user.forgot-password.enter.email.error': 'Please enter your email address',
  'user.forgot-password.invalid.email.error': 'Invalid email address',
  'user.forgot-reset-password.forgot.password.error': 'Forgot Password Error',
  'user.forgot-password.forgot.password.success.body':
    'If you are a platform user, you will receive an email with a link to reset your password',
  'user.forgot-password.forgot.password.success.title': 'Forgot Password',
  'user.forgot-reset-password.body.title': 'MAGIC IS IN THE DETAILS',
  'user.forgot-reset-password.body.body.one':
    'If you are a platform user, you will receive an email with a link to reset your password.',
  'user.forgot-reset-password.body.body.two':
    'Please use your email to reset your password.',
  'user.forgot-reset-password.body.body.three':
    'If you are not a member, please',
  'user.forgot-reset-password.body.body.register': 'register',
  'edi.nodata.available': 'No measurement available',
  'edi.connection.error': 'Connection error, please try again',
  'edi.connection.timeout': 'Request timed out, please try again',
  'edi.portfolio.market.value': 'Market Value',
  'edi.portfolio.total.surface.area': 'Total Surface Area',
  'edi.portfolio.assets.number': 'Assets Number',
  'edi.portfolio.assets.number.unit': 'properties',
  'edi.nodata.to.download': 'No data to download',
  'edi.download.minimum.period':
    'Data cannot be downloaded for periods shorter than one month',
  'city.madrid.directory': 'Directory Madrid',
  'city.barcelona.directory': 'Directory Barcelona',
  'building.floor': 'Floor',
  'building.level': 'Level',
  'building.floor.download.blueprint': 'Download',
  'building.floor.file': 'File',
  'building.client': 'Client',
  'building.no_floors': 'No floors available.',
  'building.no_icon': 'No icon',
  'card.consumption.total': 'Total',
  'card.consumption.heating': 'Heating',
  'card.consumption.cooling': 'Cooling',
  'building.heatmap': 'Heatmap',
  'disclaimer.title': 'Important Notice',
  'disclaimer.button.accept': 'Accept',
  'disclaimer.error.get': 'Error checking disclaimer status',
  'disclaimer.error.accept': 'Error saving disclaimer status',
  'client.apps.reports': 'Reports',
  'client.apps.heatmap': 'Heatmaps',
  'client.apps.intranet': 'Intranet',
  'client.apps.climate': 'Climate',
  'client.apps.lightning': 'Lighting',
  'administration.buildings.without.img': 'No image',
  'building.blueprint.implantation': 'Implantation',
  'building.blueprint.architecture': 'Architecture',
  'building.blueprint.coordination.imp': 'Implementation Coord.',
  'building.blueprint.coordination.arch': 'Architecture Coord.',
  'building.apps': 'Apps',
  'contact.with.us': 'Contact us',
  'building.blueprint.coordination': 'Coordination',
  'administration.settings.autodesk.title': 'Autodesk',
  'administration.settings.set.period.time':
    'Set Autodesk download period (hours)',
  'administration.settings.set.period.time.visualization':
    'Set Autodesk visualization period (days)',
  'administration.accounts.autodesk_id': 'ID Autodesk',
  'administration.settings.footprint_objective': 'Carbon footprint target',
  'edi.dashboard.widgets.edit-chart': 'Edit chart',
  'administration.settings.report_config': 'Advanced report settings',
  'administration.settings.manage_reports': 'Manage Reports',
  'settings.report.lang.es': 'Spanish',
  'settings.report.lang.fr': 'French',
  'settings.report.lang.cat': 'Catalan',
  'settings.report.lang.en': 'English',
  'date.sunday': 'Sunday',
  'date.monday': 'Monday',
  'date.tuesday': 'Tuesday',
  'date.wednesday': 'Wednesday',
  'date.thursday': 'Thursday',
  'date.friday': 'Friday',
  'date.saturday': 'Saturday',
  'date.january': 'January',
  'date.february': 'February',
  'date.march': 'March',
  'date.april': 'April',
  'date.may': 'May',
  'date.june': 'June',
  'date.july': 'July',
  'date.august': 'August',
  'date.september': 'September',
  'date.october': 'October',
  'date.november': 'November',
  'date.december': 'December',
  'dashboard.hide_reports_config': 'Hide reports configuration',
  'dashboard.show_reports_config': 'Show reports configuration',
  'administration.widgets.flows': 'Flows',
  'administration.widgets.deepki': 'Deepki',
  'administration.widgets.med': 'MED',
  'administration.widgets.metasys_barcelona': 'Metasys Barcelona',
  'administration.widgets.metasys_madrid': 'Metasys Madrid',
  'administration.widgets.aitea_building': 'Aitea Building',
  'administration.reports.title-1': 'Title 1',
  'administration.reports.title-2': 'Title 1.1',
  'administration.reports.title-3': 'Title 1.1.1',
  'administration.reports.title-4': 'Title 1.1.1.1',
  'administration.reports.title-5': 'Title 1.1.1.1.1',
  'administration.reports.title-6': 'Title 1.1.1.1.1.1',
  'administration.reports.text-body': 'Text body',
  'administration.reports.table-chart-title': 'Tables and charts title',
  'building.basement': 'Basement',
  'building.semi_basement': 'Semi-basement',
  'building.garage': 'Garage',
  'building.attic': 'Attic',
  'building.mezzanine': 'Mezzanine',
  'chart.unconsolidated-data': 'Current Month',
  'chart.previous-year': 'Previous Year',
  'chart.no-data': 'No data to display',
  'chart.loading': 'Loading...',
  'chart.target': 'Target 2030',
  'chart.maximum': 'Maximum',
  'chart.minimum': 'Minimum',
  'chart.co2-rite': 'Maximum CO2 reference value',
  'edi.widgets.chart-edi': 'AiteaView chart',
  'administration.building.no_certificates': 'No certificates assigned',
  'administration.permission.admin': 'Staff',
  'administration.widgets.placement.carousel': 'Carousel',
  'administration.widgets.placement.information': 'Information',
  'administration.widgets.placement.directory': 'Directory',
  'administration.widgets.placement.data': 'Data',
  'administration.group.all': 'All',
  'administration.group.building': 'Building',
  'administration.group.subbuilding': 'Sub building',
  'administration.group.client': 'Client',
  'chart.humidity-rite': 'Maximum Royal Decree 486/1997',
  'chart.humidity-min-rite': 'Minimum Royal Decree 486/1997',
  'cosbim.parameters.not-configured':
    'This building has no folders configured yet.',
  'cosbim.documents.not.found': 'No documents in this module',
  'cosbim.open.all.nodes': 'Open all folders',
  'cosbim.close.all.nodes': 'Close all folders',
  'cosbim.pdf': 'PDF',
  'cosbim.cad': 'CAD',
  'cosbim.docuware.no-ue-code':
    'This building has no economic unit code, which is what identifies it in DocuWare. Without it its documents cannot be shown.',
  'cosbim.building.not-found':
    'Building not found. Check the link: this screen only shows buildings.',
  'cosbim.docuware.forbidden':
    'You are not allowed to see this building’s documents.',
  'cosbim.docuware.unreachable':
    'No connection to DocuWare. Folders are shown empty until the service is back.',
  'cosbim.docuware.error':
    'DocuWare returned an error. Folders are shown empty, but they may well have documents.',
  'cosbim.docuware.downloading': 'Downloading...',
  'cosbim.docuware.view': 'View the document',
  'cosbim.docuware.download': 'Download the document',
  'cosbim.docuware.not_viewable':
    'This document cannot be viewed in the browser; use the icon to download it.',
  'cosbim.docuware.viewer.close': 'Close',
  'cosbim.docuware.viewer.unsupported':
    'This document cannot be displayed here; download it to open it.',
  'cosbim.docuware.download_failed': 'The document could not be downloaded',
  'cosbim.docuware.view_failed': 'The document could not be opened',
  'cosbim.docuware.retry': 'Retry',
  'cosbim.docuware.truncated':
    'There are more documents than DocuWare returns at once, so some may be missing from the list.',
  'cosbim.docuware.folder.loading': 'Loading documents...',
  'cosbim.docuware.folder.unavailable': 'Unavailable',
  'cosbim.bim.load_failed': 'BIM360 documents could not be loaded.',
  'cosbim.bim.cache_unavailable': 'Autodesk cache not available.',
  'cosbim.bim.download_failed': 'The BIM360 file could not be downloaded.',
  'cosbim.node.without_name': 'Unnamed',
  'parameters.hidden.success': 'Folder hidden',
  'parameters.visible.success': 'Folder visible',
  'documents.empty.links':
    'This building has no Link folders, which are the only ones configured here.',
  'documents.empty.no_cosbim': 'This building has no COSBIM module associated.',
  'building.autodesk-id-missing':
    'The Building does not have Autodesk ID configured.',
  'alarms.no.registred': 'No alarms registered',
  'alarms.non.critical': 'Non-critical',
  'alarms.critical': 'Critical',
  'alarms.without.message': 'No message',
  'assistant.ask': 'Ask me anything...',
  'building.contacts': 'Contacts',
  'building.information': 'Building information',
  'building.services': 'Services',
  'building.validations': 'Validations',
  'building.contacts.last.update': 'Last update',
  'building.create.service': 'Create new service',
  'building.create.validation': 'Create new validation',
  'building.edit.service': 'Edit service',
  'building.edit.validation': 'Edit validation',
  'building.service.name': 'Name',
  'building.service.description': 'Description',
  'building.validation.service': 'Service',
  'building.validation.field': 'Field',
  'building.validation.type': 'Type',
  'building.form.cups': '+ Add CUPS',
  'building.form.ue_code': '+ Add UE code',
  'building.subbuildings.ue_codes': 'Sub-building UE codes',
  'building.generate.reports': 'Generate report',
  'building.report.consumption.only.building.or.client.message':
    'The consumption report can only be generated from a building or a client',
  'consumption.report.send': 'Send',
  'date.range.invalid': 'Invalid date range',
  'consumption.report.missing_data': 'Building or client data is missing',
  'consumption.report.success': 'Report generated successfully',
  'consumption.report.generating': 'Generating report...',
  'consumption.report.no_cups':
    'This report cannot be generated for this building as it is a low-voltage building.',
  'consumption.report.email_sent': 'Report successfully sent by email.',
  'building.ue_code': 'UE Code',
  'building.tipology': 'Typology',
  'building.status': 'Status',
  'building.parent_space': 'City',
  'building.basic_data': 'Basic data',
  'building.tipology.monousuario': 'Single tenant',
  'building.tipology.multiusuario': 'Multi tenant',
  'building.tipology.en_construction': 'Under construction',
  'building.status.requerimiento': 'Requirement',
  'building.status.explotacion': 'In operation',
  'building.status.fin_de_obra': 'End of construction',
  'building.contact.tecnico': 'Associated Technician',
  'building.contact.csm': 'Associated CSM',
  'building.contact.fm': 'Facility Manager',
  'building.contact.name': 'Name',
  'building.contact.email': 'Email',
  'building.contact.phone': 'Phone',
  'building.contact.company': 'Company',
  'building.contact.24h.ssgg': '24h General Services Contact',
  'building.contact.24h.pci': '24h PCI Contact',
  'building.contact.24h.vertical_transport': '24h Vertical Transport Phone',
  'building.contact.24h.medium_voltage': '24h Medium Voltage Contact',
  'building.contact.24h.security_phone': 'Security Phone 24h',
  'building.contact.24h.vigilance': '24h Surveillance',
  'building.contact.24h': '24 Hours',
  'building.phone.hours': '24-hour phone',
  'building.phone.hours.other': '24-hour phone (other)',
  'building.contact.technician': 'Technician',
  'building.contact.coordinator': 'Coordinator',
  'building.phone.other': 'Other phone',
  'building.shift': 'Shift',
  'building.notes': 'Notes',
  'administration.services.tittle.delete':
    'Do you want to delete this service?',
  'administration.contacts.tittle.delete':
    'Are you sure you want to delete this contact?',
  'administration.settings.verification.title': 'Contact validations',
  'administration.settings.verification.enabled': 'Enable verification system',
  'administration.settings.verification.max.days': 'Maximum confirmation days',
  'administration.settings.verification.periodicity.days':
    'Validation periodicity (days)',
  'building.contacts.add.technician': 'Add contact',
  'building.contacts.delete.contact': 'Delete contact',
  'technician.created.success': 'Contact created successfully',
  'service.updated.success': 'Updated successfully',
  'service.deleted.success': 'Successfully deleted',
  'service.created.success': 'Successfully created',
  'administration.validations.tittle.delete':
    'Are you sure you want to delete this validation?',
  'email.verification.success': 'Email successfully verified',
  'email.verification.error': 'Email could not be verified',
  'email.verification.go_to_login': 'Go to login',
  'administration.contacts.permissions.title': 'Contacts permissions',
  'administration.contacts.permissions.read': 'Read',
  'administration.contacts.permissions.write': 'Write',
  'administration.contacts.permissions.validate': 'Validate',
  'building.validate.data': 'Validate data',
  'administration.settings.validation.period.days':
    'Data validation frequency (days)',
  'assistant.loading': 'Loading assistant...',
  'assistant.location.portfolio': "You are viewing [name]'s portfolio.",
  'assistant.location.city': 'You are viewing the buildings in [name].',
  'assistant.location.building': 'You are viewing [name].',
  'building.data_validated': 'Validated',
  'building.last_validated_at': 'Last validation date',
  'building.last_validated_by': 'Validated by',
  'carbon.footprint.message':
    'Operational emissions from Scope 1 + 2 + 3 according to the Greenhouse Gas Protocol (GHG Protocol) using its official market-based calculation methodology.',
  'building.contact.role': 'Role',
  'contacts.download.title': 'Generate Contacts Excel',
  'contacts.download.select.buildings': 'Select buildings to include:',
  'contacts.download.select.all': 'Select all',
  'contacts.download.download': 'Download',
  'contacts.download.send': 'Send',
  'contacts.download.no.buildings': 'Select at least one building',
  'contacts.download.success': 'Contacts Excel downloaded successfully',
  'contacts.download.email.sent': 'Contacts list sent successfully by email',
  'parameters.name.duplicated':
    'A folder with that name already exists at the same level.',
  'parameters.name.too_long':
    'The full path is over 200 characters. Shorten the name.',
  'parameters.path.preview': 'Full path',
  'parameters.node_type': 'Parameter type',
  'parameters.node_type.container': 'Container',
  'parameters.node_type.docuware': 'DocuWare container',
  'parameters.node_type.autodesk': 'AutoDesk container',
  'parameters.node_type.link': 'Link',
  'parameters.node_type.link_hint':
    'A Container only groups: to show documents, choose DocuWare Container. A Link cannot contain subfolders.',
  'parameters.node_type.link_has_children':
    'It cannot become a Link: the folder has subfolders.',
  'parameters.node_type.drop_filter':
    'Changing the type will remove the DocuWare filter.',
  'parameters.docuware.cabinet': 'File cabinet',
  'parameters.docuware.cabinet_required': 'Choose a file cabinet.',
  'parameters.docuware.cabinet_unavailable':
    'The file cabinet list could not be loaded.',
  'parameters.docuware.clase_doc': 'Doc class',
  'parameters.docuware.subclase_doc': 'Doc subclass',
  'parameters.docuware.tipo_doc': 'Doc type',
  'parameters.filter.add': 'Add',
  'parameters.filter.placeholder': 'Type a value and press Enter',
  'parameters.filter.any_of':
    'Several values in the same field show the documents matching any of them. All fields must be met at once.',
  'parameters.docuware.values_empty':
    'These values do not currently appear in any document; it may be a typo or nothing loaded with that value yet: {values}',
  'parameters.docuware.filter_empty':
    'A filter with no values would show every document of the building.',
  'parameters.docuware.checking': 'Checking in DocuWare...',
  'parameters.docuware.ok': 'The filter returns {count} documents.',
  'parameters.docuware.no_match':
    'The cabinet has {count} documents in scope, but none match this filter.',
  'parameters.docuware.field_empty':
    'This field is what leaves the filter empty.',
  'parameters.docuware.empty_scope':
    'There are no documents in this scope yet, so the filter cannot be checked.',
  'parameters.docuware.unreachable': 'No connection to DocuWare.',
  'parameters.docuware.gateway_error': 'DocuWare returned an error.',
  'parameters.docuware.no_ue_code': 'The building has no economic unit code.',
  'parameters.docuware.saves_anyway': 'The folder is saved anyway.',
  'parameters.docuware.save_anyway': 'Save anyway',
  'parameters.docuware.save_unchecked': 'Save unchecked',
  'parameters.reorder.up': 'Move up',
  'parameters.reorder.down': 'Move down',
  'parameters.empty': 'There are no folders yet.',
  'parameters.empty.search': 'No parameter matches the search.',
  'parameters.created.success': 'Folder created',
  'parameters.updated.success': 'Folder updated',
  'parameters.deleted.success': 'Folder deleted',
  'administration.widgets.plans': 'Plans',
  'administration.accounts.tittle.edit.user': 'Edit user',
  'client.reports.floors.title': 'Select the floors',
  'client.reports.floors.empty':
    'There are no floors available for this client.',
  'client.reports.floors.required': 'Select at least one floor',
  'client.reports.dashboard.required': 'Select a report',
  'client.reports.confirm': 'Confirm',
  'client.reports.cancel': 'Cancel',
  'client.reports.generate.pdf': 'Generate PDF',
  'client.reports.send.email': 'Send by email',
  'client.reports.selected.floors': 'Selected floors',
  'date.range.same.year': 'Only months within the same year can be selected',
  'client.reports.generating': 'Generating report...',
  'client.reports.pdf.success': 'Report generated successfully',
  'client.reports.email.success': 'Report sent to your email',
  'client.reports.email.sending': 'Sending the report...',
  'client.reports.pdf.error': 'The report could not be generated',
  'client.reports.floors.resolving': 'Preparing the floors...',
  'client.reports.floors.error': 'The report floors could not be resolved',
  'client.reports.module.on-floor': 'On floor',
  'client.reports.module': 'Module',
  'widgets.type.date': 'Date',
  'widgets.type.apps-carousel': 'Apps carousel',
  'widgets.type.apps-directory': 'Apps directory',
  'widgets.type.portfolio-summary': 'Portfolio summary',
  'widgets.type.weather': 'Weather',
  'widgets.type.air-quality': 'Outdoor air quality',
  'widgets.type.metric': 'Metric',
  'widgets.type.app': 'App',
  'widgets.kind.url': 'Link (url)',
  'widgets.kind.data': 'Data (data)',
  'widgets.kind.custom': 'Custom (custom)',
  'widgets.kind.custom-app': 'App with its own interface',
  'widgets.behavior.link': 'Link',
  'widgets.behavior.blueprint': 'Blueprints',
  'widgets.behavior.reports': 'Reports',
  'widgets.behavior.contacts': 'Contacts',
  'widgets.behavior.contacts_download': 'Contacts download',
  'widgets.behavior.cosbim': 'COSBIM',
  'widgets.behavior.ocas': 'OCAs',
  'widgets.behavior.assistant': 'Assistant',
  'widgets.config.behavior': 'Behavior',
  'widgets.config.node_types': 'Offered in',
  'widgets.config.required_permission': 'Required permission',
  'widgets.node_type.portfolio': 'Portfolio',
  'widgets.node_type.space': 'Space or city',
  'widgets.node_type.building': 'Building',
  'widgets.node_type.subbuilding': 'Sub-building',
  'widgets.node_type.client': 'Client',
  'widgets.public': 'Public',
  'widgets.public.help':
    "Any user with access to the entity sees it, without needing the widget's permission. It still has to be assigned to each entity.",
  'administration.ocas.filter.status.danger_warning': 'Dates in red and yellow',
  'administration.ocas.docuware_pending':
    'The document source (DocuWare) has not been configured yet: until then installations show as "Pending" with no document.',
  'administration.ocas.building.no_document': 'No document',
  'administration.ocas.building.last_sync': 'DocuWare data as of',
  'administration.ocas.building.sync_error':
    'Could not connect to DocuWare. Showing the latest available data.',
  'administration.ocas.tittle.delete':
    'Are you sure you want to delete this installation?',
  'administration.ocas.month': 'month',
  'administration.ocas.months': 'months',
  'administration.ocas.building.status.not_applicable': 'N/A',
  'administration.ocas.date.not_applicable': 'N/A',
  'administration.ocas.date.pending': 'Pending',
  'administration.ocas.building.status.pending': 'Pending',
  'administration.settings.ocas.title': 'OCA email notices',
  'administration.settings.ocas.enabled': 'Enable OCA notices',
  'administration.settings.ocas.expiry_days':
    'Days of notice before the inspection is due',
  'administration.settings.ocas.periodicity_days':
    'Days between repeated notices',
  'administration.settings.ocas.help':
    'With notices enabled, AiteaView sends a daily email to the FMs for every building with inspections about to expire, and to the FMs and the building technician when there are rejected inspections.',
  'administration.settings.ocas.save': 'Save OCA notices',
  'administration.settings.notification.ocas_updated':
    'OCA notices updated successfully',
  /* aiteaview_end_trans */
  /* aiteaassistant_start_trans */
  'example.example': 'Example',
  'assistant.title': 'Aitea Assistant',
  'assistant.say.something': 'Ask me something',
  'assistant.action.delete': 'Delete',
  'assistant.action.speaker': 'Connect to speaker',
  'assistant.action.microphone': 'Connect to microphone',
  'assistant.action.microphonestop': 'Pause microphone',
  'assistant.action.attach': 'Attach files',
  'assistant.action.alerts': 'Add alerts',
  'assistant.action.settings': 'Settings',
  'assistant.action.logout': 'Log out',
  'assistant.menu': 'Assistant',
  'assistant.initial.message': 'Hello again',
  'assistant.greeting':
    "Hello, [name]. I'm your Assistant, the tool that lets you quickly and easily access key information from Colonial's portfolio, improve maintenance KPIs, save time on daily tasks, and support quality control of operational maintenance.",
  'assistant.file.download': 'Download file',
  'assistant.file.error':
    'Error downloading the file. Files can only be downloaded once. To view it again, you need to request it again.',
  'assistant.user.pronoun': 'Me',
  'assistant.delete.disclaimer':
    'Are you sure you want to delete the conversation?',
  'assistant.delete.title': 'Delete conversation history',
  'assistant.yesterday': 'Yesterday',
  'assistant.today': 'Today',
  'assistant.thinking': 'Thinking...',
  'assistant.listening': 'Listening...',
  'assistant.playing': 'Playing...',
  'assistant.playback.speed': 'Playback speed',
  'assistant.playback.close': 'Close player',
  'assistant.finish': 'Finish',
  'assistant.reasoning': 'Reasoning',
  'assistant.feedback.title': 'How was this response?',
  'assistant.feedback.comment.placeholder': 'Comment (optional)',
  'assistant.feedback.submit': 'Submit',
  'permissions.global.assistant.use': 'Use the assistant',
  'permissions.global.assistant.use.description':
    "Ask the assistant and see one's own chat history.",
  'permissions.global.assistant.chatbot': 'Assistant in chatbot mode',
  'permissions.global.assistant.chatbot.description':
    'Use the assistant as a chatbot: it answers questions.',
  'permissions.global.assistant.agentic': 'Assistant in agentic mode',
  'permissions.global.assistant.agentic.description':
    'Use the assistant in agentic mode: besides answering, it carries out actions.',
  /* aiteaassistant_end_trans */
  /* dashboards_start_trans */
  'menu.dashboardList': 'Dashboard list',
  'dashboard.name': 'Dashboard Name',
  'dashboard.description': 'Dashboard Description',
  'dashboard.widgets': 'Widgets',
  'dashboard.widgets.chart-line': 'Line  chart',
  'dashboard.widgets.chart-area': 'Area chart',
  'dashboard.widgets.chart-column': 'Column chart',
  'dashboard.widgets.table': 'Table',
  'dashboard.widgets.counter': 'Counter',
  'dashboard.widgets.title': 'Title',
  'dashboard.widgets.text': 'Text',
  'dashboard.widgets.chart-abscissa': 'Abscissa chart',
  'dashboard.widgets.chart-pie': 'Pie chart',
  'dashboard.widgets.chart-bar-electric-use': 'Bar chart %',
  'dashboard.widgets.electric-use.types': 'Data to show',
  'dashboard.widgets.electric-use.power': 'Power',
  'dashboard.widgets.electric-use.lighting': 'Lighting',
  'dashboard.widgets.electric-use.hvac': 'HVAC',
  'dashboard.widgets.electric-use.validation-error':
    'You need to select at least one data type and the data grouping.',
  'dashboard.widgets.electric-use.no-entity':
    'This widget needs to be opened from a building, sub-building or client.',
  'dashboard.widgets.electric-use.no-module':
    'This entity has no Electricidad Uso module with the selected grouping.',
  'dashboard.widgets.create': 'Create new Widget',
  'dashboard.widgets.name': 'Widget`s Name',
  'dashboard.widgets.database': 'Database',
  'dashboard.widgets.collector': 'collector',
  'dashboard.widgets.counter.type': 'Type of value',
  'dashboard.widgets.counter.type.max': 'Max value',
  'dashboard.widgets.counter.type.last': 'Last value',
  'dashboard.widgets.content': 'Widget content',
  'dashboard.widgets.content.edit': 'Edit content',
  'dashboard.widgets.save': 'Save',
  'dashboard.widgets.delete': 'Delete',
  'dashboard.widgets.cancel': 'Cancel',
  'dashboard.widgets.add': 'Add',
  'dashboard.widgets.delete-confirmation':
    'Are you sure you want to delete the widget?',
  'dashboard.widgets.close-confirmation':
    'Are you sure you want to leave? Unsaved changes will be lost.',
  'dashboard.widgets.select': 'Select type of Widget',
  'dashboard.widgets.select.columns': 'Max columns',
  'dashboard.widgets.select-type.electrical': 'Electrical',
  'dashboard.widgets.select-type.water': 'Water',
  'dashboard.widgets.select-type.gas': 'Gas',
  'dashboard.widgets.select-type.thermal-cold': 'Thermal (cold)',
  'dashboard.widgets.select-type.thermal-hot': 'Thermal (hot)',
  'dashboard.widgets.select-type.thermal-total': 'Total thermal',
  'dashboard.widgets.select-type.temperature': 'Temperature',
  'dashboard.widgets.select-type.ext-temperature': 'Ext. Temperature',
  'dashboard.widgets.select-type.humidity': 'Humidity',
  'dashboard.widgets.select-type.ext-humidity': 'Ext. Humidity',
  'dashboard.widgets.select-type.co2': 'CO2',
  'dashboard.widgets.select-type.ext-co2': 'Ext. CO2',
  'dashboard.widgets.select-type.cala': 'Outdoor air quality',
  'dashboard.widgets.select-type.occupation-percentage':
    'Occupation Percentage',
  'dashboard.widgets.select-group.hourly': 'Hourly',
  'dashboard.widgets.select-group.daily': 'Daily',
  'dashboard.widgets.select-group.monthly': 'Monthly',
  'dashboard.widgets.select-group.yearly': 'Yearly',
  'dashboard.widgets.select-type.title-warning': 'Grouping Type Warning',
  'dashboard.widgets.select-type.body-warning':
    'The data type you selected only contains hourly data, the widget will be empty.',
  'dashboard.widgets.date.from': 'From',
  'dashboard.widgets.date.to': 'To',
  'dashboard.widgets.text.header': 'Widget Text',
  'dashboard.widgets.title.header': 'Widget Title',
  'dashboard.widgets.module.title-error': 'Module Error',
  'dashboard.widgets.module.body-error':
    'The collector {collectorType} {collectorGroupingType} of widget {widgetName} does not exist in {representName}.',
  'dashboard.widgets.multi.edit-chart': 'Edit chart',
  'dashboard.widgets.multi.content': 'Abscissa chart creation',
  'dashboard.widgets.multi.title': 'Title',
  'dashboard.widgets.multi.footer': 'Footer',
  'dashboard.widgets.multi.components': 'Components',
  'dashboard.widgets.multi.component': 'Component',
  'dashboard.widgets.multi.edit': 'Edit',
  'dashboard.widgets.multi.delete': 'Delete',
  'dashboard.widgets.multi.edit-component': 'Edit component',
  'dashboard.widgets.multi.component-name': 'Component name',
  'dashboard.widgets.multi.chart-type': 'Chart type',
  'dashboard.widgets.multi.source': 'Source',
  'dashboard.widgets.multi.color': 'Color',
  'dashboard.widgets.multi.lines': 'Lines',
  'dashboard.widgets.multi.columns': 'Columns',
  'dashboard.widgets.multi.line': 'Line',
  'dashboard.widgets.multi.min': 'Minimum',
  'dashboard.widgets.multi.mean': 'Mean',
  'dashboard.widgets.multi.max': 'Maximum',
  'dashboard.widgets.multi.default': 'Default',
  'dashboard.widgets.multi.stacked-percentage':
    'Stacked chart with percentages',
  'dashboard.widgets.multi.total-grouped': 'Totals chart grouped by component',
  'dashboard.widgets.multi.last-year-compare': 'Compare with previous year',
  'dashboard.widgets.donut.content': 'Section chart creation',
  'dashboard.widgets.collector-type': 'Data type',
  'dashboard.widgets.collector-grouping-type': 'Data grouping',
  'dashboard.widgets.edi.template-warning':
    'Edit mode, this Dashboard is a report template, to view the data access it from EDI.',
  'dashboard.widgets.edi.template-error':
    'This dashboard is a report template, access it from EDI to view the data.',
  'dashboards.create-dashboard': 'Create',
  'dashboards.create-button': 'New Dashboard',
  'dashboards.create-dashboard.title': 'Create new Dashboard',
  'dashboards.new-dashboard-name': 'Dashboard name',
  'dashboards.modify-dashboard': 'Modify',
  'dashboards.update-dashboard-name': 'Update Name',
  'dashboard.widgets.table.title': 'Table',
  'dashboard.widgets.table.columns': 'Columns',
  'dashboard.widgets.table.add.column': 'Add Column',
  'dashboard.widgets.table.rows': 'Rows',
  'dashboard.widgets.table.add.row': 'Add Row',
  'dashboard.widgets.table.footer': 'Footer',
  'dashboard.widgets.table.configure': 'Configure',
  'dashboard.widgets.table.type': 'Type',
  'dashboard.widgets.table.type.horizontal': 'Horizontal',
  'dashboard.widgets.table.type.vertical': 'Vertical',
  'dashboard.widgets.table.color.first.row': 'First Row Color',
  'dashboard.widgets.table.color.other.rows': 'Other Rows Color',
  'dashboard.widgets.table.color.other.cols': 'Other Columns Color',
  'dashboard.widgets.table.compare.hide.months': 'Hide months',
  'dashboard.widgets.table.validation.stats-required':
    'You must select at least one option in Other Rows or Other Columns',
  'dashboard.widgets.table.color.conditioned': 'Conditional Color',
  'dashboard.widgets.table.condition': 'Condition',
  'dashboard.widgets.table.others.rows': 'Other Rows',
  'dashboard.widgets.table.others.columns': 'Other Columns',
  'dashboard.widgets.table.compare.last.year': 'Compare to Last Year',
  'dashboard.widgets.table.max': 'Maximum',
  'dashboard.widgets.table.minimun': 'Minimum',
  'dashboard.widgets.table.average': 'Average',
  'dashboard.widgets.table.configuration': 'Configure',
  'dashboard.widgets.table.title-placeholder': 'Title',
  'dashboard.widgets.table.footer-placeholder': 'Footer',
  'dashboard.widgets.table.condition-placeholder':
    'E.g.: value > 27 || value < 17',
  'dashboard.create.report_properties': 'Report properties',
  'dashboard.create.report_description': 'Description',
  'dashboard.create.report_format':
    'Add report formatting (cover page, table of contents, header, and footer)',
  'dashboard.create.report_image1': 'Image 1 (right side of the footer)',
  'dashboard.create.report_image2': 'Image 2 (right side of the header)',
  'dashboard.create.report_image3': 'Image 3 (center of the cover)',
  'dashboard.report-image.low-resolution.title': 'Low image resolution',
  'dashboard.report-image.low-resolution.body':
    'The resolution of the selected image is lower than recommended and may affect how it looks in the report. We recommend using a higher-resolution image.',
  'dashboard.create.report_clients': 'Visible to clients',
  'dashboard.create.report_disclaimer': 'Disclaimer text',
  'dashboard.pdf': 'PDF',
  'dashboard.mail': 'Mail',
  'dashboard.send.mail': 'Send',
  'dashboard.send_mail': 'Send to my email',
  'dashboard.close': 'Close',
  'dashboard.create.add_cover_page': 'Add cover',
  'dashboard.create.add_index_page': 'Add index',
  'dashboard.create.add_header': 'Add header',
  'dashboard.create.add_footer': 'Add footer',
  'dashboard.create.report_disclaimer_two': 'Disclaimer text 2',
  'dashboard.title.data.quality': 'Data Quality',
  'dashboard.title.forced.points': 'Manually Forced Points',
  'dashboard.title.points.outside.rite': 'Points Outside RITE',
  'dashboard.title.vrvs.alarms': 'VRVs with Filter Alarm',
  'dashboard.title.data.frequency': 'Data Collection Frequency Analysis',
  'dashboard.title.abnormal.electrical.electrical':
    'Abnormal Electrical Consumption',
  'dashboard.title.startup.recommendation': 'Startup Recommendation',
  'dashboard.create.corporate_text': 'Corporate text',
  'dashboard.dashboards.delete-confirmation':
    'Are you sure you want to delete this report?',
  'dashboard.save.success': 'The dashboard has been saved successfully.',
  'dashboard.table.total': 'Total',
  'dashboard.table.total.accumulated': 'Accumulated Total',
  'dashboard.table.min': 'Minimum',
  'dashboard.table.avg': 'Average',
  'dashboard.table.stat': 'Statistic',
  'dashboard.table.year': 'Year',
  'dashboard.table.month': 'Month',
  'dashboard.table.value': 'Value',
  'dashboard.table.floor': 'Floor',
  'dashboard.table.module': 'Module',
  'dashboard.month.short.jan': 'Jan',
  'dashboard.month.short.feb': 'Feb',
  'dashboard.month.short.mar': 'Mar',
  'dashboard.month.short.apr': 'Apr',
  'dashboard.month.short.may': 'May',
  'dashboard.month.short.jun': 'Jun',
  'dashboard.month.short.jul': 'Jul',
  'dashboard.month.short.aug': 'Aug',
  'dashboard.month.short.sep': 'Sep',
  'dashboard.month.short.oct': 'Oct',
  'dashboard.month.short.nov': 'Nov',
  'dashboard.month.short.dec': 'Dec',
  'dashboard.level.title1': 'Title 1',
  'dashboard.level.title1_1': 'Title 1.1',
  'dashboard.level.title1_1_1': 'Title 1.1.1',
  'dashboard.level.title1_1_1_1': 'Title 1.1.1.1',
  'dashboard.level.title1_1_1_1_1': 'Title 1.1.1.1.1',
  'dashboard.level.title1_1_1_1_1_1': 'Title 1.1.1.1.1.1',
  'dashboard.groupType.building': 'Building',
  'dashboard.groupType.client': 'Client',
  'dashboard.groupType.subbuilding': 'Sub Building',
  'dashboard.groupType.spaces': 'City',
  'dashboard.groupType.portfolio': 'Portfolio',
  'dashboard.upload.select-image': 'Select image',
  'dashboard.date.range.warning':
    'Reports cannot be generated with more than one year selected in the date range.',
  'electric.consumption': 'Electrical consumption',
  'water.cons': 'Water consumption',
  'gas.cons': 'Gas consumption',
  'districlima.cons': 'Thermal consumption (total)',
  'chart.temp': 'Temperature',
  'districlima.cons.cold': 'Thermal consumption (cold)',
  'districlima.cons.hot': 'Thermal consumption (hot)',
  'chart.humid': 'Humidity',
  'chart.humid.ext': 'External humidity',
  'metric.occup': 'Occupancy percentage',
  'temp.ext': 'External temperature',
  'dashboard.generator': 'Report generator',
  'dashboard.report.headless.loading': 'Loading report data...',
  'dashboard.report.headless.rendering': 'Rendering report charts...',
  'dashboard.report.headless.generating': 'Creating the report PDF...',
  'dashboard.report.headless.done': 'Report generated.',
  'dashboard.report.headless.timeout-error':
    'The report took too long to generate. Please try again or narrow the date range.',
  'dashboard.report.headless.error': 'The report PDF could not be generated.',
  'dashboard.generate.pdf': 'Generate',
  'dashboard.widgets.image': 'Image',
  'dashboard.widgets.image.empty': 'This widget has no image.',
  'dashboard.widgets.image.file': 'Widget image',
  'dashboard.widgets.image.help':
    'JPEG, PNG, WebP or GIF, up to 5 MB. It fits the widget size without distortion.',
  'dashboard.widgets.image.invalid-type':
    'Unsupported format. Use JPEG, PNG, WebP or GIF.',
  'dashboard.widgets.image.too-large':
    'The image exceeds the maximum size of 5 MB.',
  'dashboard.widgets.image.required': 'Select an image.',
  /* dashboards_end_trans */
};
